module.exports = __webpack_public_path__ + "assets/img/12.89aef8fe.gif";